import { HttpApiSchema } from "@effect/platform";
import { Schema } from "effect";

/**
 * A Meta (Facebook/Instagram) comment action (hide, delete, like, edit) failed
 * in a way the merchant can act on. Carries a human-readable `userMessage` so
 * the UI surfaces the real cause instead of collapsing every Meta failure into
 * an opaque "service temporarily unavailable" toast.
 *
 * Mirrors the `MessageSendBlockedError` pattern: a tagged error in the RPC
 * contract that the support-v2 `catchApiErrors` handler surfaces verbatim.
 */
export class MetaCommentActionFailedError extends Schema.TaggedError<MetaCommentActionFailedError>()(
  "MetaCommentActionFailedError",
  {
    /** Merchant-facing message describing what went wrong and what to do. */
    userMessage: Schema.String,
    /** Transient failure (rate limit / Meta outage); retrying may work. */
    retryable: Schema.Boolean,
  },
  HttpApiSchema.annotations({ status: 422 }),
) {}
